import { render } from "./InviteLink.vue?vue&type=template&id=0d52c0a8&scoped=true"
import script from "./InviteLink.vue?vue&type=script&lang=js"
export * from "./InviteLink.vue?vue&type=script&lang=js"

import "./InviteLink.vue?vue&type=style&index=0&id=0d52c0a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d52c0a8"]])

export default __exports__